import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Flatpickr from 'react-flatpickr'
import { Swedish } from 'flatpickr/dist/l10n/sv.js'
import { English } from 'flatpickr/dist/l10n/default.js'
import useUrlParams from 'hooks/useUrlParams'
import 'flatpickr/dist/themes/light.css'
import IconCalendar from 'components/partials/IconCalendar'
import ClearButton from 'components/ClearButton'

function DatePicker({ param, placeholder, id }) {
  const { t, i18n } = useTranslation()
  const { urlParams, updateUrlParams } = useUrlParams()
  const [date, setDate] = useState(urlParams[param])
  const flatPicker = useRef();

  useEffect(() => {
    setDate(urlParams[param])
  }, [urlParams[param]])

  const handleChange = (date) => {
    updateUrlParams({ [param]: date })
  }

  const handleOnClick = (datePicker) => {
    datePicker.flatpickr.open()
  }

  const handleClearClick = (fieldName) => {
    updateUrlParams({
      [fieldName]: undefined
    })
    setDate(undefined)
  }

  return (
    <div className="date-picker u-flex u-align-center">
      <div className="u-position-relative">
        <Flatpickr
          ref={flatPicker}
          className="form-item__input form-item__input--text form-item__input--date u-width-full"
          id={id}
          placeholder={placeholder || t('Choose')}
          value={date}
          onChange={(_, dateStr) => handleChange(dateStr)}
          options={{
            ariaDateFormat: 'd M, Y',
            locale: i18n.language === 'sv' ? Swedish : { ...English, firstDayOfWeek: 1 }
          }}
        />
        { date && (
          <ClearButton
            modifierClasses='form-item__clear'
            label={`${t('Clear selection')}`}
            onClick={() => handleClearClick(param)}
          />
        )}
      </div>
      <button
        className="date-picker__button"
        aria-label={`${t('Open datepicker')} ${placeholder.toLowerCase()}`}
        role="button"
        onClick={(e) => {
          handleOnClick(flatPicker.current);
        }}
      >
        <IconCalendar />
      </button>
    </div>
  )
}

export default DatePicker
